import React from 'react';
import { useFormContext, Controller } from 'react-hook-form';
import { Button, TextInput } from 'components';
import { TTagForm, TTagFormValues } from './TagForm.types';

const TagForm: TTagForm = ({ onSubmit, isLoading = false }) => {
  const { handleSubmit, control } = useFormContext<TTagFormValues>();

  const onFormSubmit = (data: TTagFormValues) => {
    onSubmit(data);
  };

  return (
    <div className="admin-form">
      <form
        onSubmit={handleSubmit(onFormSubmit)}
        className="admin-form__form"
        noValidate
      >
        <div className="admin-form__form-content">
          <div className="admin-form__field">
            <Controller
              name="name"
              control={control}
              render={({ field, fieldState }) => (
                <TextInput
                  label="Name"
                  onChange={field.onChange}
                  value={field.value ?? ''}
                  error={!!fieldState.error}
                  helperText={fieldState.error?.message}
                  required
                />
              )}
            />
          </div>

          <div className="admin-form__field">
            <Controller
              name="color"
              control={control}
              render={({ field, fieldState }) => (
                <TextInput
                  type="color"
                  label="Color"
                  onChange={field.onChange}
                  value={field.value ?? ''}
                  error={!!fieldState.error}
                  helperText={fieldState.error?.message}
                  required
                  InputLabelProps={{
                    shrink: true,
                  }}
                  inputProps={{
                    style: {
                      height: '56px',
                      cursor: 'pointer',
                    },
                  }}
                />
              )}
            />
          </div>
        </div>

        <div className="admin-form__actions">
          <Button variant="contained" type="submit" disabled={isLoading}>
            Save
          </Button>
        </div>
      </form>
    </div>
  );
};

export default TagForm;
